import PageWrapper from "../../../../components/common/layout/PageWrapper";
import { useTranslation } from "react-i18next";
import GroupsAndRolesTabs from "../../../../components/admin/groupsAndRoles/GroupsAndRolesTabs";

const GroupsAndRolesManagement = () => {
  const { t } = useTranslation();

  return (
    <PageWrapper title={t("t.page.groupsAndRoles.admin")}>
      <GroupsAndRolesTabs />
    </PageWrapper>
  );
};

export default GroupsAndRolesManagement;
